module.exports = __webpack_public_path__ + "static/media/fillword-bg.f4abe3f8.png";